import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'orchestra-home',
  templateUrl: './orchestra-home.component.html',
  styleUrls: ['./orchestra-home.component.scss']
})
export class OrchestraHomeComponent implements OnInit {
  tooltipVisible = false;
  tooltipTarget:any = null;
  tooltipPosition:any = { my: 'left', offset: '-80 0' };
  tooltipContent:string = '';

  constructor(
    public global: GlobalService,
    public auth: AuthService) { }

  ngOnInit() {
  }
}
